import{useState,useEffect}from'react'
import{supabase}from'./supabase'
import EventList from'./components/EventList'
import NewEventForm from'./components/NewEventForm'
import EventDetail from'./components/EventDetail'
import Auth from'./components/Auth'
import Onboarding from'./components/Onboarding'
import Subscribe from'./components/Subscribe'
import useOrg from'./useOrg'
import'./App.css'

function App(){
const[session,setSession]=useState(null)
const[loading,setLoading]=useState(true)
const[showForm,setShowForm]=useState(false)
const[selectedEvent,setSelectedEvent]=useState(null)
const[refresh,setRefresh]=useState(0)
const[onboarded,setOnboarded]=useState(()=>localStorage.getItem('gr_onboarded')==='true')
const{orgId,plan}=useOrg(session?.user?.id)

useEffect(()=>{
supabase.auth.getSession().then(({data:{session}})=>{
setSession(session)
setLoading(false)
})
supabase.auth.onAuthStateChange((_event,session)=>{
setSession(session)
})
},[])

async function handleSignOut(){
await supabase.auth.signOut()
setSelectedEvent(null)
setShowForm(false)
}

if(loading)return<div style={{padding:'2rem'}}>Loading...</div>
if(!session)return<Auth/>
if(!onboarded)return<Onboarding onComplete={()=>{localStorage.setItem('gr_onboarded','true');setOnboarded(true);setShowForm(true)}}/>
if(selectedEvent)return<EventDetail eventId={selectedEvent} orgId={orgId} onBack={()=>setSelectedEvent(null)}/>

return(
<div>
<div className='header' style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
<h1 style={{color:'white',fontSize:'20px',fontWeight:'600'}}>Greenroom</h1>
<button onClick={handleSignOut} style={{background:'none',border:'1px solid rgba(255,255,255,0.4)',color:'white',padding:'6px 14px',borderRadius:'6px',fontSize:'13px',cursor:'pointer'}}>Sign out</button>
</div>
{showForm&&<NewEventForm orgId={orgId} onClose={()=>setShowForm(false)} onCreated={()=>{setShowForm(false);setRefresh(r=>r+1)}}/>}
<EventList key={refresh} orgId={orgId} plan={plan} onNewEvent={()=>setShowForm(true)} onSelectEvent={(id)=>setSelectedEvent(id)}/>
    <Subscribe/>
</div>
)}

export default App